import { useCallback, useEffect, useState } from 'react';
import { useAdminApi, ApiError } from '../../../Admin/shared/adminApi';
import type { ReferralListResponse, ReferralListFilters } from './types';

export function useReferralList(filters: ReferralListFilters) {
  const { request } = useAdminApi();
  const [data, setData] = useState<ReferralListResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(
        await request<ReferralListResponse>({
          env: 'prod',
          path: '/admin/analytics/referrals/list',
          query: filters,
        }),
      );
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Failed to load referrals');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [request, JSON.stringify(filters)]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    void load();
  }, [load]);

  return { data, error, loading, reload: load };
}
